/* =============================================================================
   Farmoxa Premium — collection page helpers: grid/list toggle, facet "toon meer",
   mobile filter button. Re-applies after Dawn's facets.js re-renders the grid.
   ============================================================================= */
(() => {
  'use strict';
  const page = document.querySelector('[data-fmx-collection]');
  if (!page) return;

  /* ------------------------------------------------------------ view toggle */
  const KEY = 'fmx-view';
  let view = 'grid';
  try { view = localStorage.getItem(KEY) || 'grid'; } catch (e) { /* storage unavailable */ }
  function applyView() {
    const grid = page.querySelector('#product-grid');
    if (grid) grid.classList.toggle('fmx-grid--list', view === 'list');
    page.querySelectorAll('[data-fmx-view]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.fmxView === view ? 'true' : 'false'));
  }
  page.querySelectorAll('[data-fmx-view]').forEach((b) => {
    b.addEventListener('click', () => {
      view = b.dataset.fmxView;
      try { localStorage.setItem(KEY, view); } catch (e) { /* ignore */ }
      applyView();
    });
  });
  applyView();

  /* ---------------------------------------------------------- facets extras */
  function initFacets() {
    page.querySelectorAll('.fmx-facets .facets__disclosure-vertical').forEach((d) => {
      const list = d.querySelector('.facets__list--vertical');
      if (!list || d.querySelector('.fmx-facets__more')) return;
      const items = list.querySelectorAll('li');
      if (items.length <= 6) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fmx-facets__more';
      const more = page.dataset.labelMore || 'Toon meer';
      const less = page.dataset.labelLess || 'Toon minder';
      const render = () => {
        const exp = d.classList.contains('is-expanded');
        btn.innerHTML = `<span>${exp ? less : more}</span><svg class="fmx-i" viewBox="0 0 24 24" aria-hidden="true"><path d="${exp ? 'M6 15l6-6 6 6' : 'M6 9l6 6 6-6'}"/></svg>`;
        btn.setAttribute('aria-expanded', exp ? 'true' : 'false');
      };
      btn.addEventListener('click', () => { d.classList.toggle('is-expanded'); render(); });
      render();
      list.after(btn);
    });
  }
  initFacets();
  const container = document.getElementById('ProductGridContainer');
  const facets = page.querySelector('.facets-container');
  const mo = new MutationObserver(() => { applyView(); initFacets(); });
  if (container) mo.observe(container, { childList: true });
  if (facets) mo.observe(facets, { childList: true, subtree: true });

  /* ------------------------------------------------------- mobile filters */
  page.querySelector('[data-fmx-open-filters]')?.addEventListener('click', () => {
    const summary = page.querySelector('.mobile-facets__disclosure summary');
    if (summary) summary.click();
  });
})();
